import Routes from "./routes";
/// <reference path="../../../infrastructure/types/window.d.ts" />

// Inspired from https://github.com/thedevdrawer/spa-routing
export default class Router {
  private applicationTitle: string;
  private appDiv: HTMLElement;
  private description = document.querySelector('meta[name="description"]');
  private routes: Routes;

  constructor(
    ApplicationRoot: HTMLElement,
    ApplicationTitle: string,
    ApplicationRoutes: Routes
  ) {
    this.applicationTitle = ApplicationTitle;
    this.appDiv = ApplicationRoot;
    this.routes = ApplicationRoutes;
  }

  // create a function that watches the url and calls the urlLocationHandler
  private Navigate = (event) => {
    event = event || window.event; // get window.event if event argument not provided
    event.preventDefault();
    let link: string;
    if (event.target.tagName == "A") {
      var anchor = event.target as HTMLAnchorElement;
      link = anchor.href;
    } else {
      var span = event.target as HTMLElement;
      link = span.getAttribute("data-route")!;
    }
    // window.history.pushState(state, unused, target link);
    window.history.pushState({}, "", link);
    this.LocationHandler();
  };

  private LoadScript = (src) => {
    return new Promise((resolve, reject) => {
      const id: string = "page-script";
      const script = document.createElement("script") as HTMLScriptElement;
      script.type = "text/javascript";
      script.setAttribute("id", id);
      script.onload = resolve;
      script.onerror = reject;
      script.src = src;
      document.head.append(script);
    });
  };

  private LoadLink = (href) => {
    return new Promise((resolve, reject) => {
      const id: string = "page-link";
      const link = document.createElement("link") as HTMLLinkElement;
      link.rel = "stylesheet";
      link.setAttribute("id", id);
      link.onload = resolve;
      link.onerror = reject;
      link.href = href;
      document.head.append(link);
    });
  };

  private RemoveElement = (elementName: string) => {
    if (document.contains(document.getElementById(elementName))) {
      document.getElementById(elementName)?.remove();
    }
  };

  private EmptyElement = (element: HTMLElement) => {
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
  };

  // create a function that handles the url location
  private LocationHandler = async () => {
    let location = window.location.pathname; // get the url path
    // if the path length is 0, set it to primary page route
    if (location.length == 0) {
      location = "/";
    }
    // get the route object from the urlRoutes object
    var route = this.routes.find(location) || this.routes.find("404");
    // get the html from the template
    const html =
      route!.html ||
      (await fetch(route!.template).then((response) => response.text()));
    this.EmptyElement(this.appDiv);
    this.RemoveElement("page-script");
    this.RemoveElement("page-link");
    // set the content of the content div to the html
    if (route!.script == "" && route!.link == "") {
      this.appDiv.insertAdjacentHTML("beforeend", html);
    } else if (route!.script != "" && route!.link != "") {
      this.LoadLink(route!.link)
        .then((script) => this.LoadScript(route!.script))
        .then((div) => this.appDiv.insertAdjacentHTML("beforeend", html))
        .catch(() =>
          console.error("Error while trying to add script and link")
        );
    } else if (route!.script != "" && route!.link == "") {
      this.LoadScript(route!.script)
        .then((div) => this.appDiv.insertAdjacentHTML("beforeend", html))
        .catch(() => console.error("Error while trying to add script"));
    } else if (route!.script == "" && route!.link != "") {
      this.LoadLink(route!.link)
        .then((div) => this.appDiv.insertAdjacentHTML("beforeend", html))
        .catch(() => console.error("Error while trying to add link"));
    }
    // set the title of the document to the title of the route
    document.title = route!.title + " | " + this.applicationTitle;
    // set the description of the document to the description of the route
    this.description!.setAttribute("content", route!.description);
  };

  public RouterInit = async () => {
    // create document click that watches the nav links only
    document.addEventListener("click", async (event) => {
      if (event !== null && event.target !== null) {
        const target = event.target as Element;
        if (target.matches("nav a") || target.matches("nav span")) {
          event.preventDefault();
          this.Navigate(event);
        }
        return;
      }
      return;
    });
    // Preload Pages
    for (let key of this.routes.keys()) {
      var route = this.routes.find(key);
      if (route != null && route.html == "") {
        route.html = await fetch(route.template).then((response) =>
          response.text()
        );
      }
    }
    // add an event listener to the window that watches for url changes
    window.onpopstate = this.LocationHandler;
    // call the LocationHandler function to handle the initial url
    (window as any).route = this.Navigate;
    this.LocationHandler();
  };
}
